
export enum Tables  {
    BILLING_HISTORY = 'billing_history',
    BILLING_INFO = 'billing_info',
    COST_COMPARISONS = 'cost_comparisons',
    CREDIT_USAGE_HISTORY = 'credit_usage_history',
    GROUPS = 'groups',
    INVOICES = 'invoices',
    MERCHANTS = 'merchants',
    ORGANIZATIONS = 'organizations',
    PAYMENT_PLANS = 'payment_plans',
    PROPOSALS = 'proposals',
    REGISTRATION_FORMS = 'registration_forms',
    ROLES = 'roles',
    STATEMENTS = 'statements',
    SUBSCRIPTIONS = 'subscriptions',
    TEAMS = 'teams',
    USERS = 'users'
}
